export { cs } from "./cs";
export { de } from "./de";
export { en } from "./en";
export { fr } from "./fr";

import { en } from "./en";

/** Default English locale strings; week start comes from {@link localeTag} via Intl. */
export const DEFAULT_LOCALE = en;
